import mitt from "mitt";

const emitter = mitt();

export const MODAL_TYPES = {
  EXIT: "EXIT_MODAL",
  SUPPORT_SENDED: "SUPPORT_SENDED",
  FEEDBACK_SENDED: "FEEDBACK_SENDED",
  BUY_GAME: "BUY_GAME",
  RESET: "RESET_MODAL",
  SWIPER: "SWIPER_MODAL",
  MAKE_DECISION: "MAKE_DECISION",
  HELP_COMPROMISE: "HELP_COMPROMISE",
  REMOVE_GAME: "REMOVE_GAME",
  REMOVE_PROFILE: "REMOVE_PROFILE",
  MARATHON_PREPARE_TIP: "MARATHON_PREPARE_TIP",
  MARATHON_INSTRUCTION: "MARATHON_INSTRUCTION",
  FEEDBACK_MODAL: "FEEDBACK_MODAL",
  MOBILE_LAST_ANSWERS: "MOBILE_LAST_ANSWERS",
  TO_MENU: "TO_MENU",
  ADULT_ALERT: "ADULT_ALERT",
  ALREADY_USED_LINK: "ALREADY_USED_LINK",
  LINK_WAS_NOT_SENT: "LINK_WAS_NOT_SENT",
  FIRST_TIME_PLAYING: "FIRST_TIME_PLAYING",
  WANT_TO_KNOW: "WANT_TO_KNOW",
  RESTORE_DEMO_PROGRESS: "RESTORE_DEMO_PROGRESS",
  USING_PREV_GAME_ANSWER: "USING_PREV_GAME_ANSWER",
  TAKE_ADVANTAGE_INSIGHT_FORM: "TAKE_ADVANTAGE_INSIGHT_FORM",
  SUCCESSFULY_SAVED_QUEST_FORM_MODAL: "SUCCESSFULY_SAVED_QUEST_FORM_MODAL",
  INSIGHT_INVITE_PARTNER_SENT: "INSIGHT_INVITE_PARTNER_SENT",
  INSIGHT_ANSWER_PARTNER_SENT: "INSIGHT_ANSWER_PARTNER_SENT",
  INSIGHT_FORM_SENT_SUCCESSFULY: "INSIGHT_FORM_SENT_SUCCESSFULY",
  SHOW_INSIGHT_FORM_INVITE: "SHOW_INSIGHT_FORM_INVITE",
  SHOW_END_GAME: "SHOW_END_GAME",
  INSIGHT_FORM_CAN_WATCH_NOTIFY: "INSIGHT_FORM_CAN_WATCH_NOTIFY",
  ZONE_COMFORT_INSTRUCTION: "ZONE_COMFORT_INSTRUCTION",
  ZONE_INTEREST_INSTRUCTION: "ZONE_INTEREST_INSTRUCTION",
  ZONE_STUDY_INSTRUCTION: "ZONE_STUDY_INSTRUCTION",
  ZONE_DIALOGUE_INSTRUCTION: "ZONE_DIALOGUE_INSTRUCTION",
  ZONE_CONTRADICTION_INSTRUCTION: "ZONE_CONTRADICTION_INSTRUCTION",
  ZONE_AGREEMENT_INSTRUCTION: "ZONE_AGREEMENT_INSTRUCTION",
  PARTNER_BOUGHT_GAME: "PARTNER_BOUGHT_GAME",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  // 23.10: ввод кода подтверждения почты при регистрации
  EMAIL_CODE: "EMAIL_CODE",
  // Этап 2: лояльность и новые продукты
  BUY_PRODUCT: "BUY_PRODUCT",
  // Демо: «Хочешь увидеть весь тест полностью?» — два тарифа (тест-88 + полная игра)
  // + пояснительный блок «Обрати внимание!» (Figma 12414-50766 / mobile 12414-50754)
  SEE_FULL_TEST: "SEE_FULL_TEST",
  NOT_ENOUGH_POINTS: "NOT_ENOUGH_POINTS",
  POINTS_CONGRATS: "POINTS_CONGRATS",
  POINTS_INSTRUCTION: "POINTS_INSTRUCTION",
  CREATE_TEST_INFO: "CREATE_TEST_INFO",
  PURCHASE_FAILED: "PURCHASE_FAILED",
  BLANK_FORM_DETAILS: "BLANK_FORM_DETAILS",
  BLANK_RECOMMENDATION: "BLANK_RECOMMENDATION",
  EXT57_INTRO: "EXT57_INTRO",
  EXT57_OFFER: "EXT57_OFFER",
  PARTNER_UNLOCKED_57: "PARTNER_UNLOCKED_57",
  // item 20a: подтверждение прохождения +57 при нажатии «Играть» с зелёным кружком
  EXT57_CONTINUE: "EXT57_CONTINUE",
  // item 6: игрок прошёл свои +57, партнёр ещё нет → статус «ждём партнёра»
  EXT57_WAIT_PARTNER: "EXT57_WAIT_PARTNER",
  COMPLETE_TEST_TO_SEE_RESULTS: "COMPLETE_TEST_TO_SEE_RESULTS",
  CHOOSE_YOUR_GENDER: "CHOOSE_YOUR_GENDER",
  GENDER_NOTIFICATION: "GENDER_NOTIFICATION",
  ADD_MAIN_SCREEN: "ADD_MAIN_SCREEN",
  PERMISSION: "PERMISSION",
};

export const QUESTIONARIE_EVENTS = {
  INSIGHT_INVITED: "INSIGHT_INVITED",
  REJECT_STATUS: "REJECT_STATUS",
  WATCH_STATUS: "SET_WATCH_STATUS",
  INVITE_PARTNER: "INVITE_PARTNER",
};

export const SWIPER_ACTIONS = {
  SHOW_NEXT_SLIDE: "SHOW_NEXT_SLIDE",
};


export const REQUEST_DATA_REFRESH = {
  /**
   * Триггер для вызова события сокета который запрашивает обновление данных
   */
  REQUEST_REFRESH_GAME_DATA: "REQUEST_REFRESH_GAME_DATA", 
};

export default emitter;
